import types from './types';

const initialState = {
  fetchingGalleryInformation: false,
  requiresPhotoApproval: false,
  pending: {
    photosPendingApproval: [],
    count: 0,
    performingAction: false
  },
  metrics: {
    roomPhotosPercentage: [],
    numberOfPhotosSentToday: 0
  },
  meta: {
    downloadingPhotos: false
  }
};

export const galleryReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CENTER_GALLERY_INFORMATION_REQUEST: {
      return {
        ...state,
        fetchingGalleryInformation: true
      };
    }
    case types.GET_CENTER_GALLERY_INFORMATION_SUCCESS: {
      return {
        ...state,
        fetchingGalleryInformation: false,
        requiresPhotoApproval: action.pendingPhotosData.requiresPhotoApproval,
        pending: {
          ...state.pending,
          ...action.pendingPhotosData.pendingPhotos
        },
        metrics: {
          ...state.metrics,
          roomPhotosPercentage: action.metricsData.byRoom,
          numberOfPhotosSentToday: action.metricsData.numberOfPhotosSentToday
        }
      };
    }
    case types.GET_CENTER_GALLERY_INFORMATION_FAILURE: {
      return {
        ...state,
        fetchingGalleryInformation: false
      };
    }
    case types.APPROVE_PENDING_PHOTO_REQUEST:
    case types.REJECT_PENDING_PHOTO_REQUEST: {
      return {
        ...state,
        pending: {
          ...state.pending,
          performingAction: true
        }
      };
    }
    case types.APPROVE_PENDING_PHOTO_SUCCESS:
    case types.REJECT_PENDING_PHOTO_SUCCESS: {
      let pendingPhotosCopy = [...state.pending.photosPendingApproval];

      // iterate over each photo that was approved/denied and remove from redux if necessary
      action.photoIds.forEach(idObject => {
        const { photoId, childId } = idObject;

        pendingPhotosCopy.forEach((pending, index) => {
          const { group_image_id: groupImageId, child_id: _childId } = pending;

          // if a pending photo in redux has the same groupImageId and childId, remove it
          if (
            (parseInt(photoId, 10) === parseInt(groupImageId, 10)) &&
            (parseInt(childId, 10) === parseInt(_childId, 10))
          ) {
            pendingPhotosCopy.splice(index, 1);
          }
        });
      });

      return {
        ...state,
        pending: {
          photosPendingApproval: pendingPhotosCopy,
          count: state.count - action.photoIds.length,
          performingAction: false
        }
      };
    }
    case types.APPROVE_PENDING_PHOTO_FAILURE:
    case types.REJECT_PENDING_PHOTO_FAILURE: {
      return {
        ...state,
        pending: {
          ...state.pending,
          performingAction: false
        }
      };
    }
    case types.DOWNLOAD_PHOTOS_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          downloadingPhotos: true
        }
      };
    }
    case types.DOWNLOAD_PHOTOS_SUCCESS:
    case types.DOWNLOAD_PHOTOS_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          downloadingPhotos: false
        }
      };
    }
    default:
      return state;
  }
};
